/**
 * Copyright (c) 2007-2012 Ariel Flesler - aflesler(at)gmail(dot)com | http://flesler.blogspot.com
 * Dual licensed under MIT and GPL.
 * @author Ariel Flesler
 * @version 1.4.3.1
 */
$ = jQuery.noConflict();
(function ($) {

    $.fn.topLink = function (settings) {
        settings = jQuery.extend({
            min: 1,
            fadeSpeed: 200,
            ieOffset: 50
        }, settings);
        return this.each(function () {
            var el = $(this);
            el.css('display', 'none');
            $(window).scroll(function () {
                if ($(window).scrollTop() >= settings.min) {
                    el.fadeIn(settings.fadeSpeed);
                } else {
                    el.fadeOut(settings.fadeSpeed);
                }
            });
        });
    };

        var pathname = window.location.pathname;
        var pieces = pathname.split("/");

        var bckttpStr = 'Back to top';
        var bckttpCStr = '<a href="#page" id="auto-top-link" title="' + Drupal.t(bckttpStr) + '"></a>';

        $("footer").append(bckttpCStr);

      
        //$("footer").append('<a href="#page" id="auto-top-link" title="Back to top"></a>');

        $('#auto-top-link').topLink({
            min: 1,
            fadeSpeed: 300
        });

        //smoothscroll
        $('#auto-top-link').click(function (e) {
            e.preventDefault();
            var offset = $("body").offset();
            $("html,body").animate({
                scrollTop: 0,
            });
        });

})(jQuery);
